import React, { useEffect } from "react";
import { SignIn, useAuth } from "@clerk/clerk-react";
import { useLocation, useNavigate } from "react-router-dom";
import "./Landing.css";
import BeforeAfterShowcase from "./BeforeAfterShowcase";
import { clerkAppearance, applyClerkAuthSupplementalStyles } from "../../config/app/clerkAppearance";
import { BRAND_LOGO, BRAND_NAME } from "../../config/app/brandAssets";
import { resolveAuthReturnPath } from "../../utils/authReturnPath";

const Landing = () => {
  const { isSignedIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const returnPath = resolveAuthReturnPath(location.search) || "/dashboard";
  const signUpUrl =
    returnPath === "/dashboard"
      ? "/login"
      : `/login?redirect=${encodeURIComponent(returnPath)}`;

  useEffect(() => {
    applyClerkAuthSupplementalStyles();
    const timer = setTimeout(applyClerkAuthSupplementalStyles, 100);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (isSignedIn) {
      navigate(returnPath, { replace: true });
    }
  }, [isSignedIn, navigate, returnPath]);

  if (isSignedIn) {
    return null;
  }

  return (
    <div className="landing-container">
      <div className="landing-background-slider">
        <BeforeAfterShowcase />
      </div>

      <div className="landing-overlay"></div>

      <div className="landing-hero">
        <div className="landing-hero-row">
          <div className="landing-content">
            <p className="landing-subtitle">
              Remove backgrounds instantly with AI-powered precision
            </p>
          </div>

          <div className="landing-auth-section">
            <img
              className="landing-auth-logo"
              src={BRAND_LOGO.sidebar}
              alt={BRAND_NAME}
            />

            <div className="clerk-auth-wrapper">
              <SignIn
                routing="hash"
                appearance={clerkAppearance}
                withSignUp
                afterSignInUrl={returnPath}
                afterSignUpUrl={returnPath}
                signUpUrl={signUpUrl}
                fallbackRedirectUrl={returnPath}
                forceRedirectUrl={returnPath}
                signUpForceRedirectUrl={returnPath}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Landing;
